import { createGlobalStyle } from 'styled-components';
import theme from './theme';

/**
 * Global styles for the GeoDiet application
 * Note: Google Font 'DM Sans' is linked in index.html
 */
const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: ${theme.colors.textPrimary};
    background-color: ${theme.colors.background};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: ${theme.colors.primary};
    transition: ${theme.transition.default};

    &:hover {
      color: ${theme.colors.primaryDark};
    }
  }

  button {
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }

  input, textarea, select {
    font-family: 'DM Sans', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${theme.typography.weights.semiBold};
    line-height: 1.2;
    margin-bottom: 0.5em;
  }

  h1 {
    font-size: ${theme.typography.sizes.xxxl};
  }

  h2 {
    font-size: ${theme.typography.sizes.xxl};
  }

  h3 {
    font-size: ${theme.typography.sizes.xl};
  }

  h4 {
    font-size: ${theme.typography.sizes.lg};
  }

  h5 {
    font-size: ${theme.typography.sizes.md};
  }

  h6 {
    font-size: ${theme.typography.sizes.base};
  }

  p {
    margin-bottom: 1em;
  }

  ul, ol {
    margin-bottom: 1em;
    padding-left: 1.5em;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${theme.spacing.md};
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;

export default GlobalStyles; 